var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","width":"100%"}},[_c('indexTitle',[_vm._v(_vm._s(_vm.$t(("lang." + _vm.title)))+" ")]),_vm._v(" "),(_vm.more)?_c('span',{staticClass:"seemore",on:{"click":_vm.go2seeMore}},[_vm._v(_vm._s(_vm.$t('lang.查看更多'))+" "),_c('i',{staticClass:"iconfont icon-right1"})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e3a1f5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/wenxing/components/seeMoreAndTitleRow.vue
// module id = null
// module chunks = 